(function () {
  // Attivo solo sul template planned-collection
  if (!document.body.classList.contains('template-product') ||
      !document.body.classList.contains('template-suffix-planned-collection')) return;

  function enforceMultiple(input) {
    const step = parseInt(input.getAttribute('data-qty-step')) || 1;
    const min = parseInt(input.getAttribute('data-min')) || step;

    if (step <= 1) return; // Nessuna restrizione per prodotti normali

    // Arrotonda al multiplo più vicino
    let value = parseInt(input.value) || min;
    if (value < min) value = min;
    const remainder = value % step;
    if (remainder !== 0) {
      value = value - remainder + step;
    }
    input.value = value;
  }

  function initQuantityControls() {
    document.querySelectorAll('quantity-input').forEach(function (qtyInput) {
      const input = qtyInput.querySelector('.quantity__input');
      if (!input || !input.getAttribute('data-qty-step')) return;

      const step = parseInt(input.getAttribute('data-qty-step')) || 1;
      if (step <= 1) return;

      const min = parseInt(input.getAttribute('data-min')) || step;

      // Imposta il valore iniziale corretto
      if (!input.value || parseInt(input.value) < min) {
        input.value = min;
      }

      // Pulsante MINUS
      const minusBtn = qtyInput.querySelector('[name="minus"]');
      if (minusBtn) {
        minusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          let current = parseInt(input.value) || min;
          let newVal = current - step;
          input.value = newVal < min ? min : newVal;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      // Pulsante PLUS
      const plusBtn = qtyInput.querySelector('[name="plus"]');
      if (plusBtn) {
        plusBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          let current = parseInt(input.value) || min;
          const max = input.getAttribute('max') ? parseInt(input.getAttribute('max')) : null;
          let newVal = current + step;
          if (max && newVal > max) newVal = current;
          input.value = newVal;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      // Correzione se l'utente digita manualmente
      input.addEventListener('change', function () {
        enforceMultiple(input);
      });

      input.addEventListener('blur', function () {
        enforceMultiple(input);
      });
    });
  }

  // Inizializzazione al caricamento
  document.addEventListener('DOMContentLoaded', function () {
    initQuantityControls();

    // Reinizializza se la variante cambia (es. selezione colore/taglia)
    document.addEventListener('variant:changed', function () {
      setTimeout(initQuantityControls, 300);
    });
  });
})();
